export default __webpack_public_path__ + "static/media/F0007.3b845686.png";